
import {
    SET_API_KEY, GET_API_KEY
} from "@/modules/service-account/domain/store/service-account.types";

const state = {
    apiKey: {},
};

const getters = {
    [GET_API_KEY]: (state) => state.apiKey,
};

const actions = {};

const mutations = {
    [SET_API_KEY]: (state, data) => {
        state.apiKey = data
    },
};

export default {
    namespaced: true,
    state: {
        ...state
    },
    getters: {
        ...getters
    },
    actions: {
        ...actions
    },
    mutations: {
        ...mutations
    }
};
